
import { dispatcher, serverData } from "@aceroll/core";
import sounds from './Sounds';

class WinAnimation {
    slotMachine = null;

    constructor() {
        this.duration = 4;
        this.resumeDuration = 1.9;
        this.timeline = null;
    }

    async playActions(actions) {
        if (!actions || !actions.length) {
            return;
        }

        for (let i = 0; i < actions.length; i++) {
            const action = actions[i];

            await this.playAction(action);
        }
    }

    playAction(action) {
        switch (action.type) {
            case 'gridwin':
                return this._playWinLine(action.data);

            case 'bonusfeaturewon':
                if (action.data.name === 'respin') {
                    return this._playFeatureRespin(action.data);
                }
                if (action.data.name === 'freespin') { return this._playFeatureFreespin(action.data); }
            case 'add':
                return this._playMultiplier(action.data);
            case 'multiply':
                return this._playMultiplier(action.data);


            default:
                return Promise.resolve();
        }
    }
    /**
     * Start the win animation.
     */
    async start() {
        const response = serverData.currentResponse;
        const winLines = response.winLines || [];
    }

    _getDuration(count) {
        let duration = 0;
        for (let i = 0; i < count; i++) {
            duration += 0.5 / (0.1 * i + 2); // Example formula for calculating duration
        }
        return duration;
    }

    _hasGrid(actions) {
        return actions.length && actions.filter(action => action.type === "gridwin").length > 0;
    }

    playTotalWin(response) {
        if (!response.parsed.gridWonSymbols || !response.parsed.gridWonSymbols.length) { return Promise.resolve(); }
        // TODO: add win ticker. Big win if any
        const { actions } = response.parsed;

        if (this._hasGrid) {
            const gridwinActions = actions.filter(action => action.type === "gridwin");
        }

        const winMultiplier = response.winAmount / serverData.roundBet;

        const isBonus = serverData.currentFeature === 'bonus_1' || serverData.currentFeature === 'bonus_2';

        switch (true) {
            case winMultiplier >= 16:
                if (!isBonus) {
                    sounds.playLevelAmbient(4);
                }
                this.playCharacter('hugeWin');
                this.playBonusWin();
                this.playFire();
                break;
            case winMultiplier >= 11:
                if (!isBonus) {
                    sounds.playLevelAmbient(3);
                }
                this.playCharacter('bigWin');
                this.playBonusWin();
                break;
            case winMultiplier >= 6:
                if (!isBonus) {
                    sounds.playLevelAmbient(2);
                }
                this.playCharacter('averageWin');
                this.playBonusWin();
                break;
            case winMultiplier >= 2:
                this.playCharacter('minWin');
                break;
        }

        const slotMachine = dispatcher.app.layout.slotMachine;

        const lines = actions.filter(action => action.type === 'gridwin');
        const groups = this.groupWinLines(lines, +serverData.roundBet);

        return slotMachine.playWin(groups);
    }

    async _playMultiplier(data) {
        const { values, positions } = data;
        const totalMultiplierAfterAdding = values[1];

        const { multiplierPanel } = dispatcher.app.layout;

        const slotMachine = dispatcher.app.layout.slotMachine;

        await slotMachine.playMultipliers(positions[0]);
        await multiplierPanel.updateMultiplier(totalMultiplierAfterAdding);
    }

    _playWinLine(data) {
        const positions = data.positions;
        return this.slotMachine.playWinLine(positions);
    }

    _playFeatureRespin(data) {
        if (!data) {
            return;
        }

        const { multiplierPanel, slotMachine } = dispatcher.app.layout;

        const { count } = data;


        if (serverData.currentFeature === 'bonus_1') {
            multiplierPanel.showBonus(1, false);
        } else {
            multiplierPanel.showBase(1);
        }

        return slotMachine.playRespinTrigger(data, count);
    }

    _getSymbolIdsByFeatureName(name) {
        if (name === 'respin') {
            return [13, 15];
        }
    }

    playCharacter(winType) {
        const character = dispatcher.app.layout.character;

        return character.playWin(winType);
    }

    playFire() {
        const background = dispatcher.app.layout.background;

        return background.playFire();
    }

    playBonusWin() {
        const background = dispatcher.app.layout.background;

        return background.playBonusWin();
    }

    _getSoundName(symbolId) {
        let soundName = 'low';
        switch (symbolId) {
            case 6: soundName = 'high_1';
                break;
            case 7: soundName = 'high_2';
                break;
            case 8: soundName = 'high_3';
                break;
            case 9: soundName = 'high_4';
                break;
            case 10: soundName = 'high_5';
                break;

        }
        return soundName;
    }

    groupWinLines(lines, bet) {
        lines = this.sortWinLines(lines);
        const groups = [];

        class Group {
            positions = null;
            totalWin = 0;
            baseTotalWin = 0;
            multiplier = 1;
            symbolId = null;
            lines = [];
            cheap = false;

            constructor(lines) {
                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i];
                    this.lines.push(line);

                    this.totalWin += line.winAmount;
                    this.baseTotalWin += line.baseWinAmount || 0;
                    if (line.multipliers && line.multipliers.length) {
                        this.multiplier = line.multipliers[0];
                    }
                }
                this.positions = this.mergePositions(lines);
                this.symbolId = parseInt(lines[0].symbol);
                this.cheap = bet >= this.totalWin;
            }

            mergePositions(lines) {
                let positions = [];

                for (let i = 0; i < lines.length; i++) {
                    positions.push(...lines[i].positions);
                }

                positions = positions.sort((a, b) => a.reel - b.reel);

                const uniquePositions = [...new Set(positions.map(p => `${p.reel}-${p.row}`))].map(p => {
                    const res = {
                        reel: +[p[0]],
                        row: +[p[2]]
                    };

                    return res;
                });

                return uniquePositions;
            }
        }

        let prev = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].data;

            if (!prev.length) {
                prev.push(line);
                continue;
            }
            if (line.symbol === prev[0].symbol) {
                prev.push(line);
                continue;
            }
            groups.push(new Group(prev));
            prev = [];
            prev.push(line);
        }
        if (prev.length) {
            groups.push(new Group(prev));
        }

        return groups;
    }

    sortWinLines(lines) {
        return lines.sort((a, b) => parseInt(b.data.symbol) - parseInt(a.data.symbol));
    }


}

export default new WinAnimation();
